var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',_vm._b({attrs:{"getFreshData":true,"rowClick":_vm.rowClick}},'v-data-table',_vm.vBind,false))}
var staticRenderFns = []

export { render, staticRenderFns }